import type { AuthErrorCopy } from "../components/auth-copy";

/**
 * Passwords that Supabase rejects on the server only. The page checklist
 * (length, upper case, lower case, number) cannot see them:
 *
 * - `weak_password`: the password is in a known data leak (leaked-password
 *   protection, checked on sign-up and on every password change).
 * - `same_password`: a password change sent the current password again.
 *
 * A retry with the same password fails the same way, so the routes return the
 * code with status 400 and the page tells the user what to change. A generic
 * "try again" left a partner applicant stuck on 2026-10-05.
 */
const PASSWORD_REJECTION_CODES = ["weak_password", "same_password"] as const;

export type PasswordRejectionCode = (typeof PASSWORD_REJECTION_CODES)[number];

export const toPasswordRejectionCode = (code: string | undefined): PasswordRejectionCode | null =>
  PASSWORD_REJECTION_CODES.find((candidate) => candidate === code) ?? null;

export const passwordRejectionMessage = (code: PasswordRejectionCode, errors: Pick<AuthErrorCopy, "passwordLeaked" | "passwordSame">): string =>
  code === "weak_password" ? errors.passwordLeaked : errors.passwordSame;
